import { Autocomplete, Checkbox, TextField } from '@mui/material';
import type { AccountDetails } from '../../../api/models/filters.model';

interface AccountNameFilterFieldProps {
	values: AccountDetails[];
	label?: string;
	value: AccountDetails[];
	onChange: (val: AccountDetails[]) => void;
}

function AccountNameFilterField({
	values,
	label = 'Account Name',
	value,
	onChange,
}: AccountNameFilterFieldProps) {
	return (
		<Autocomplete
			multiple
			options={values}
			getOptionLabel={(option) => option.sourceName}
			value={Array.isArray(value) ? value : []}
			onChange={(_, newValue) => onChange(newValue)}
			disableCloseOnSelect
			renderOption={(props, option, { selected }) => (
				<li {...props} key={option.sourceId}>
					<Checkbox style={{ marginRight: 8 }} checked={selected} />
					{option.sourceName}
				</li>
			)}
			renderInput={(params) => (
				<TextField {...params} label={label} placeholder="Select accounts" />
			)}
			data-testid="account-name-filter"
		/>
	);
}

export default AccountNameFilterField;
